import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpClient} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// Other modules
import {AppComponent} from './app.component';
// Routes
import {AppRoutingModule} from './app.routes';
// Components
import {HeaderComponent} from './shared/header/header.component';
import {FooterComponent} from './shared/footer/footer.component';
import {AboutComponent} from './user/components/about/about.component';
import {
  AddEditEnterpriseComponent
} from './user/components/enterprise/add-edit-enterprise/add-edit-enterprise.component';
import {ListEnterpriseComponent} from './user/components/enterprise/list-enterprise/list-enterprise.component';
import {ListPersonComponent} from './user/components/person/list-person/list-person.component';
import {AddEditPersonComponent} from './user/components/person/add-edit-person/add-edit-person.component';
import {DeletePersonComponent} from './user/components/person/delete-person/delete-person.component';
import {LoadingComponent} from './shared/loading/loading.component';
import {InformComponent} from './shared/inform/inform.component';
import {ListDocumentComponent} from './user/components/document/list-document/list-document.component';
import {AddDocumentBatchComponent} from './user/components/document/add-document-batch/add-document-batch.component';
import {DeleteEnterpriseComponent} from './user/components/enterprise/delete-enterprise/delete-enterprise.component';
import {VerifierComponent} from './public/components/verifier/verifier.component';
import {ReviewDocumentComponent} from './user/components/document/review-document/review-document.component';
import {ListWorkflowComponent} from './user/components/workflow/list-workflow/list-workflow.component';
import {AddEditWorkflowComponent} from './user/components/workflow/add-edit-workflow/add-edit-workflow.component';
import {
  AddgroupParticipantComponent
} from './user/components/participant/addgroup-participant/addgroup-participant.component';
import {AddDocumentOneComponent} from './user/components/document/add-document-one/add-document-one.component';
import {SignComponent} from './public/components/sign/sign.component';
// Pipes
import {EnterpriseNamePipe} from './user/pipes/enterprise-name.pipe';
import {NamePipe} from './user/pipes/name.pipe';
import {DateformatPipe} from './user/pipes/dateformat.pipe';
import {DescriptionParticipantTypePipe} from './user/pipes/participant-type.pipe';
import {AuthInterceptorService} from './user/service/auth-interceptor.service';
import {LoginComponent} from './user/components/login/login.component';
import {DescriptionPipe} from './user/pipes/description.pipe';
import {DescriptionDocumentTypePipe} from './user/pipes/description-document-type.pipe';
import {JobDescriptionPipe} from './user/pipes/job-description.pipe';
import {CopyclipboardComponent} from './shared/copyclipboard/copyclipboard.component';
import {
  AssignWorkflowPersonComponent
} from './user/components/person/assign-workflow-person/assign-workflow-person.component';
import {ViewParticipantComponent} from './user/components/document/view-participant/view-participant.component';
import {ListJobComponent} from './user/components/job/list-job/list-job.component';
import {AddEditJobComponent} from './user/components/job/add-edit-job/add-edit-job.component';
import {
  NotifyPostOperationComponent
} from './user/components/participant/notify-post-operation/notify-post-operation.component';
import {
  ListSieCredentialComponent
} from './user/components/sie-credential/list-sie-credential/list-sie-credential.component';
import {
  AddSieCredentialComponent
} from './user/components/sie-credential/add-sie-credential/add-sie-credential.component';
import {QuillModule} from 'ngx-quill';
import {
  TemplateDesignWorkflowComponent
} from './user/components/workflow/design-template-workflow/template-design-workflow.component';
import {AlifeFileToBase64Module} from 'alife-file-to-base64';
import {
  PreviewTemplateWorkflowComponent
} from './user/components/workflow/preview-template-workflow/preview-template-workflow.component';
import {VerifierbycodeComponent} from './public/components/verifierbycode/verifierbycode.component';
import {ConfirmComponent} from './shared/confirm/confirm.component';
import {ListAuthorityComponent} from './user/components/authority/list-authority/list-authority.component';
import {AddEditAuthorityComponent} from './user/components/authority/add-edit-authority/add-edit-authority.component';
import {ListRoleComponent} from './user/components/role/list-role/list-role.component';
import {AddEditRoleComponent} from './user/components/role/add-edit-role/add-edit-role.component';
import {
  AssignAuthorityRoleComponent
} from './user/components/role/assign-authority-role/assign-authority-role.component';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive';
import {IdleconfirmComponent} from './shared/idleconfirm/idleconfirm.component';
import {
  AddDocumentOneDynamicComponent
} from './user/components/document/add-document-one-dynamic/add-document-one-dynamic.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {
  ReasignParticipantComponent
} from './user/components/document/reasign-participant/reasign-participant.component';
import {CancelDocumentComponent} from './user/components/document/cancel-document/cancel-document.component';
import {
  ViewObservationCancelComponent
} from './user/components/document/view-observation-cancel/view-observation-cancel.component';
import {ViewDocumentComponent} from './user/components/document/view-document/view-document.component';
import {ProfileComponent} from './user/components/profile/profile.component';
import {
  RecoverPasswordFirstStepComponent
} from './public/components/recover-password-first-step/recover-password-first-step.component';
import {
  RecoverPasswordSecondStepComponent
} from './public/components/recover-password-second-step/recover-password-second-step.component';
import {
  RecoverPasswordThirdStepComponent
} from './public/components/recover-password-third-step/recover-password-third-step.component';
import {RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings} from 'ng-recaptcha';
import {environment} from '../environments/environment';
import {AlertAddDocumentComponent} from './shared/alert/alert-add-document/alert-add-document.component';
import {GlobalConfigComponent} from './user/components/global-config/global-config.component';
import {
  AssignBalanceEnterpriseComponent
} from './user/components/enterprise/assign-balance-enterprise/assign-balance-enterprise.component';
import {
  ViewHistoricalBalanceComponent
} from './user/components/enterprise/view-historical-balance/view-historical-balance.component';
import {DatetimeformatPipe} from './user/pipes/datetimeformat.pipe';
import {BuyBalanceComponent} from './user/components/balance/buy-balance/buy-balance.component';
import {CardBalanceComponent} from './shared/card-balance/card-balance.component';
import {ViewBalanceComponent} from './user/components/balance/view-balance/view-balance.component';
import {SendToEmailComponent} from './user/components/document/send-to-email/send-to-email.component';
import {
  SignDocumentInternalComponent
} from './user/components/document/sign-document-internal/sign-document-internal.component';
import {ModifyDocumentComponent} from './user/components/document/modify-document/modify-document.component';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {ColorPickerModule} from 'ngx-color-picker';
import {FinalizeDocumentComponent} from './user/components/document/finalize-document/finalize-document.component';
import {ListInstallerComponent} from './user/components/installer/list-installer/list-installer.component';
import {AddEditInstallerComponent} from './user/components/installer/add-edit-installer/add-edit-installer.component';
import {ReviewComponent} from './public/components/review/review.component';
import {
  DeleteDocumentPermanentelyComponent
} from './user/components/document/delete-document-permanentely/delete-document-permanentely.component';
import {DocumentPreviewComponent} from './user/components/document/document-preview/document-preview.component';
import {
  DesignTenorToNotifyComponent
} from './user/components/workflow/design-tenor-to-notify/design-tenor-to-notify.component';
import {ViewDescriptionComponent} from './user/components/installer/view-description/view-description.component';
import {
  ListTsaCredentialComponent
} from './user/components/tsa-credential/list-tsa-credential/list-tsa-credential.component';
import {
  AddEditTsaCredentialComponent
} from './user/components/tsa-credential/add-edit-tsa-credential/add-edit-tsa-credential.component';
import {
  ComponentVerificationComponent
} from './public/components/component-verification/component-verification.component';
import {CertificateDetailComponent} from './public/components/certificate-detail/certificate-detail.component';
import {AddPeopleBatchComponent} from './user/components/person/add-people-batch/add-people-batch.component';
import {
  ComplexDocumentSearchComponent
} from './user/components/document/complex-document-search/complex-document-search.component';
import {Select2Module} from 'ng-select2-component';
import {TempLoginComponent} from './user/components/temp-login/temp-login.component';
import {
  ListInvitedDocumentComponent
} from './user/components/document/list-invited-document/list-invited-document.component';
import {
  ListBatchLoadingComponent
} from './user/components/batch-loading/list-batch-loading/list-batch-loading.component';
import {
  DetailBatchLoadingComponent
} from './user/components/batch-loading/detail-batch-loading/detail-batch-loading.component';
import {PdfViewerComponent} from './shared/pdf-viewer/pdf-viewer.component';
import {SignatureReportComponent} from './user/components/reports/signature-report/signature-report.component';
import {
  DetailSignatureReportComponent
} from './user/components/reports/detail-signature-report/detail-signature-report.component';
import {
  ConsolidatedServicesReportComponent
} from './user/components/reports/consolidated-services-report/consolidated-services-report.component';
import {
  ConsolidatedCardsReportComponent
} from './user/components/reports/consolidated-cards-report/consolidated-cards-report.component';
import {
  ConsolidatedIOFConsumptionComponent
} from './user/components/reports/consolidated-iof-consumption/consolidated-iof-consumption.component';
import {
  IofConsumptionReportComponent
} from './user/components/reports/iof-consumption-report/iof-consumption-report.component';
import {
  IofConsumptionReportDetailComponent
} from './user/components/reports/iof-consumption-report-detail/iof-consumption-report-detail.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateModule, TranslateLoader, TranslateCompiler} from '@ngx-translate/core';
import {TranslateMessageFormatCompiler} from 'ngx-translate-messageformat-compiler';
import {
  DownloadGroupDocumentComponent
} from './user/components/document/download-group-document/download-group-document.component';
import {ParameterBoardComponent} from './user/components/parameter/parameter-board/parameter-board.component';
import {
  AssignSignatureDescriptionComponent
} from './shared/assign-signature-description/assign-signature-description.component';
import {
  ViewDocumentDetailComponent
} from './user/components/document/view-document-detail/view-document-detail.component';
import {AddManageDocumentComponent} from './user/components/document/add-manage-document/add-manage-document.component';
import {
  AddDocumentNotifyBatchComponent
} from './user/components/document/add-document-notify-batch/add-document-notify-batch.component';
import {StorageUnitTypePipe} from './user/pipes/storage-unit-type.pipe';
import {ReportStorageComponent} from './user/components/reports/report-storage/report-storage.component';
import {ListTemplateComponent} from './user/components/template/list-template/list-template.component';
import {AddEditTemplateComponent} from './user/components/template/add-edit-template/add-edit-template.component';
import {AddFontPropertyComponent} from './shared/property/add-font-property/add-font-property.component';
import {AddImagePropertyComponent} from './shared/property/add-image-property/add-image-property.component';
import {PreviewTemplateComponent} from './user/components/template/preview-template/preview-template.component';
import {AddTablePropertyComponent} from './shared/property/add-table-property/add-table-property.component';
import {ListAdsComponent} from './user/components/ads/list-ads/list-ads.component';
import {AddEditAdsComponent} from './user/components/ads/add-edit-ads/add-edit-ads.component';
import {ShowImageAdsComponent} from './user/components/ads/show-image-ads/show-image-ads.component';
import {UserRegisterComponent} from './public/components/user-register/user-register.component';
import {ConfirmationCodeComponent} from './public/components/confirmation-code/confirmation-code.component';
import {DateTimePickerComponent} from './shared/date-time-picker/date-time-picker.component';
import {DocumentValidatorComponent} from './public/components/document-validator/document-validator.component';
import {SessionInactivityComponent} from './shared/session-inactivity/session-inactivity.component';
import {SignaturePadComponent} from './shared/signature-pad/signature-pad.component';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatIconModule} from '@angular/material/icon';
import {NgxImageCompressService} from 'ngx-image-compress';
import {AcceptTermsConditionsComponent} from './shared/accept-terms-conditions/accept-terms-conditions.component';
import {TermPdfViewerComponent} from './shared/term-pdf-viewer/term-pdf-viewer.component';
import {EmailEditorModule} from 'angular-email-editor';
import {
  DesignEmailTemplateComponent
} from './user/components/workflow/design-email-template/design-email-template.component';
import {IdentityValidationComponent} from './shared/identity-validation/identity-validation.component';
import {ShowCopyUrlComponent} from './user/components/document/show-copy-url/show-copy-url.component';
import {ShowForwardUrlComponent} from './user/components/document/show-forward-url/show-forward-url.component';
import {ChangePasswordComponent} from './public/components/change-password/change-password.component';
import {BillingServicesComponent} from './user/components/billing/billing-services/billing-services.component';
import {WelcomeToSignComponent} from './public/components/welcome-to-sign/welcome-to-sign.component';
import {AddOrDrawRubricComponent} from './public/components/add-or-draw-rubric/add-or-draw-rubric.component';
import {
  SignedDocumentViewerComponent
} from './public/components/signed-document-viewer/signed-document-viewer.component';
import {
  RequestOnesignOtpCodeComponent
} from './public/components/request-onesign-otp-code/request-onesign-otp-code.component';
import {
  RemoteSigningCredentialComponent
} from './public/components/remote-signing-credential/remote-signing-credential.component';
import {
  IdentityValidationSignComponent
} from './public/components/identity-validation-sign/identity-validation-sign.component';
import {DocumentViewerComponent} from './public/components/document-viewer/document-viewer.component';
import {
  RequestCertificateOnesignComponent
} from './public/components/request-certificate-onesign/request-certificate-onesign.component';
import {
  AcceptTermConditionOnesignComponent
} from './public/components/accept-term-condition-onesign/accept-term-condition-onesign.component';
import {BillingDetailComponent} from './shared/billing-detail/billing-detail.component';
import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import {ServicesReportComponent} from './user/components/reports/services-report/services-report.component';
import { ServicesReportDetailComponent } from './user/components/reports/services-report-detail/services-report-detail.component';
import {
  BillingServicesAddComponent
} from './user/components/billing/billing-services-add/billing-services-add.component';
import {
  PersonDataConfirmationComponent
} from './public/components/person-data-confirmation/person-data-confirmation.component';

registerLocaleData(localeEs, 'es');

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    AddEditEnterpriseComponent,
    ListEnterpriseComponent,
    LoadingComponent,
    InformComponent,
    SignaturePadComponent,
    AddEditPersonComponent,
    ListPersonComponent,
    DateformatPipe,
    DeletePersonComponent,
    ListDocumentComponent,
    ComponentVerificationComponent,
    ListTsaCredentialComponent,
    AddEditTsaCredentialComponent,
    AddDocumentBatchComponent,
    AddDocumentNotifyBatchComponent,
    DateTimePickerComponent,
    BillingDetailComponent,
    DeleteEnterpriseComponent,
    DescriptionParticipantTypePipe,
    VerifierComponent,
    ReviewComponent,
    ReviewDocumentComponent,
    AddDocumentOneComponent,
    BillingServicesComponent,
    BillingServicesAddComponent,
    ListWorkflowComponent,
    AddEditWorkflowComponent,
    AddgroupParticipantComponent,
    DescriptionParticipantTypePipe,
    EnterpriseNamePipe,
    SignComponent,
    SignComponent,
    NamePipe,
    LoginComponent,
    DescriptionPipe,
    DescriptionDocumentTypePipe,
    JobDescriptionPipe,
    CopyclipboardComponent,
    AssignWorkflowPersonComponent,
    AssignSignatureDescriptionComponent,
    ViewParticipantComponent,
    ListJobComponent,
    AddEditJobComponent,
    NotifyPostOperationComponent,
    ListSieCredentialComponent,
    AddSieCredentialComponent,
    ListInstallerComponent,
    AddEditInstallerComponent,
    TemplateDesignWorkflowComponent,
    PreviewTemplateWorkflowComponent,
    VerifierbycodeComponent,
    ConfirmComponent,
    ListAuthorityComponent,
    AddEditAuthorityComponent,
    ListRoleComponent,
    AddEditRoleComponent,
    AssignAuthorityRoleComponent,
    IdleconfirmComponent,
    IdentityValidationComponent,
    AddDocumentOneDynamicComponent,
    ReasignParticipantComponent,
    CancelDocumentComponent,
    PersonDataConfirmationComponent,
    ViewObservationCancelComponent,
    ViewDescriptionComponent,
    ViewDocumentComponent,
    ViewDocumentDetailComponent,
    ProfileComponent,
    RecoverPasswordFirstStepComponent,
    RecoverPasswordSecondStepComponent,
    RecoverPasswordThirdStepComponent,
    AlertAddDocumentComponent,
    GlobalConfigComponent,
    AssignBalanceEnterpriseComponent,
    ViewHistoricalBalanceComponent,
    DatetimeformatPipe,
    BuyBalanceComponent,
    CardBalanceComponent,
    ViewBalanceComponent,
    SendToEmailComponent,
    SignDocumentInternalComponent,
    ModifyDocumentComponent,
    FinalizeDocumentComponent,
    DeleteDocumentPermanentelyComponent,
    DocumentPreviewComponent,
    DesignTenorToNotifyComponent,
    CertificateDetailComponent,
    ComplexDocumentSearchComponent,
    AddPeopleBatchComponent,
    TempLoginComponent,
    ListInvitedDocumentComponent,
    ListBatchLoadingComponent,
    DetailBatchLoadingComponent,
    PdfViewerComponent,
    SignatureReportComponent,
    DetailSignatureReportComponent,
    ConsolidatedServicesReportComponent,
    ConsolidatedCardsReportComponent,
    ConsolidatedIOFConsumptionComponent,
    IofConsumptionReportComponent,
    IofConsumptionReportDetailComponent,
    DownloadGroupDocumentComponent,
    ParameterBoardComponent,
    AddManageDocumentComponent,
    StorageUnitTypePipe,
    ReportStorageComponent,
    ListTemplateComponent,
    AddEditTemplateComponent,
    AddFontPropertyComponent,
    AddImagePropertyComponent,
    PreviewTemplateComponent,
    AddTablePropertyComponent,
    ListAdsComponent,
    AddEditAdsComponent,
    ShowImageAdsComponent,
    UserRegisterComponent,
    ConfirmationCodeComponent,
    DocumentValidatorComponent,
    SessionInactivityComponent,
    AcceptTermsConditionsComponent,
    TermPdfViewerComponent,
    DesignEmailTemplateComponent,
    ShowCopyUrlComponent,
    ShowForwardUrlComponent,
    ChangePasswordComponent,
    WelcomeToSignComponent,
    AddOrDrawRubricComponent,
    SignedDocumentViewerComponent,
    RequestOnesignOtpCodeComponent,
    RemoteSigningCredentialComponent,
    IdentityValidationSignComponent,
    DocumentViewerComponent,
    RequestCertificateOnesignComponent,
    AcceptTermConditionOnesignComponent,
    ServicesReportComponent,
    ServicesReportDetailComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    QuillModule.forRoot(),
    AlifeFileToBase64Module,
    NgIdleKeepaliveModule.forRoot(),
    DragDropModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    PdfJsViewerModule,
    ColorPickerModule,
    Select2Module,
    TranslateModule.forRoot(
      {
        defaultLanguage: 'es',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        },
        compiler: {
          provide: TranslateCompiler,
          useClass: TranslateMessageFormatCompiler
        }
      }),
    MatTabsModule,
    MatIconModule,
    EmailEditorModule
  ],
  exports: [TranslateModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'es'
    }, {
      provide: RECAPTCHA_SETTINGS,
      useValue: {siteKey: environment.recaptchaSiteKey} as RecaptchaSettings
    },
    NgxImageCompressService
  ],
  entryComponents: [
    AddgroupParticipantComponent,
    AddEditEnterpriseComponent,
    AddDocumentBatchComponent,
    AddDocumentNotifyBatchComponent,
    AddEditWorkflowComponent,
    AddDocumentOneComponent,
    AddEditPersonComponent,
    DeletePersonComponent,
    DeleteEnterpriseComponent,
    InformComponent,
    ReviewDocumentComponent,
    AssignWorkflowPersonComponent,
    AssignSignatureDescriptionComponent,
    ViewParticipantComponent,
    AddEditJobComponent,
    NotifyPostOperationComponent,
    AddSieCredentialComponent,
    TemplateDesignWorkflowComponent,
    PreviewTemplateWorkflowComponent,
    ConfirmComponent,
    AddEditAuthorityComponent,
    AddEditRoleComponent,
    AssignAuthorityRoleComponent,
    IdleconfirmComponent,
    ChangePasswordComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
